import { useTeam } from "contexts/TeamContext";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "../teams/components/TeamSettings.module.css";
import { Users, ChevronRight } from "lucide-react";
import { getJoinCodeByTeamId } from "../../services/queries/joinCodeQueries";
import {
  DEMO_TEAMS,
  DEMO_STATUS_CAPS,
  TeamDemoPatternSubline,
} from "./teamDemoShared";
import { setHasSeenTeamDemo } from "../teams/teamDemoStorage";

const DEMO_JOIN_CODE = "JAD46F";

const TEAM_CARD_ICON_SLOTS = ["slot-a", "slot-b", "slot-c", "slot-d"] as const;

const TeamDemo = () => {
  const { organizationId } = useTeam();
  const navigate = useNavigate();
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [joinCode, setJoinCode] = useState<string | null>(null);
  const [joinCodeCopied, setJoinCodeCopied] = useState(false);

  const displayJoinCode =
    joinCode != null && joinCode !== "" ? joinCode : DEMO_JOIN_CODE;

  const copyJoinCode = async () => {
    const text = String(displayJoinCode);
    try {
      await navigator.clipboard.writeText(text);
      setJoinCodeCopied(true);
      window.setTimeout(() => setJoinCodeCopied(false), 2000);
      setNotification({
        show: true,
        message: "Join code copied to clipboard",
        type: "success",
      });
      window.setTimeout(() => {
        setNotification({ show: false, message: "", type: "" });
      }, 2200);
    } catch {
      setNotification({
        show: true,
        message: "Could not copy join code",
        type: "error",
      });
    }
  };

  useEffect(() => {
    const fetchJoinCode = async () => {
      const code = await getJoinCode(organizationId);
      setJoinCode(code);
    };
    if (organizationId) {
      fetchJoinCode();
    }
  }, [organizationId]);

  const getJoinCode = async (orgId: string) => {
    try {
      const joinCodeDoc = await getJoinCodeByTeamId(orgId);
      if (!joinCodeDoc) {
        console.log("No join-team code found for orgId:", orgId);
        return null;
      }
      console.log("Join code data:", joinCodeDoc);
      console.log("Join code orgId:", orgId);

      return joinCodeDoc.code;
    } catch (error) {
      console.error("Error getting join-team code:", error);
      return null;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <div className="settings-element-header">
        <p className={`settings-element-title page-title`}>Team trends</p>
      </div>

      {/* Mobile-Optimized Notification Component */}
      {notification.show && (
        <div
          className={`notification-enter team-settings-notification ${
            notification.type === "error"
              ? "team-settings-notification--error"
              : "team-settings-notification--success"
          }`}
        >
          {/* Icon Container */}
          <div className="team-settings-notification-icon">
            {notification.type === "error" ? "⚠️" : "✅"}
          </div>

          {/* Message Container */}
          <div className="team-settings-notification-message">
            <span className="team-settings-notification-title">
              {notification.type === "error" ? "Error" : "Success"}
            </span>
            <span className="team-settings-notification-text">
              {notification.message}
            </span>
          </div>

          {/* Close Button */}
          <button
            onClick={() =>
              setNotification({ show: false, message: "", type: "" })
            }
            className="team-settings-notification-close"
          >
            ×
          </button>
        </div>
      )}

      <div
        style={{
          flex: 1,
          marginLeft: "16px",
          marginRight: "16px",
        }}
      >
        <h4>Pariticipation rate: 80%</h4>

        <div className={styles["team-demo-card-list"]}>
          {DEMO_TEAMS.map(({ name, status, pattern }, idx) => (
            <button
              key={idx}
              type="button"
              className={styles["team-demo-card"]}
              onClick={() => {
                navigate(
                  `/app/demo-team/weekly?team=${encodeURIComponent(name)}`
                );
              }}
            >
              <div className={styles["team-demo-card-body"]}>
                <div
                  className={`${styles["team-demo-card-icon"]} ${styles[`team-demo-card-icon--${TEAM_CARD_ICON_SLOTS[idx % TEAM_CARD_ICON_SLOTS.length]}`]}`}
                  aria-hidden
                >
                  <Users size={20} strokeWidth={2} color="#ffffff" />
                </div>
                <div className={styles["team-demo-card-text-col"]}>
                  <span className={styles["team-demo-card-title"]}>{name}</span>
                  <span
                    className={`${styles["team-demo-card-badge"]} ${styles[`team-demo-status-${status}`]}`}
                  >
                    {DEMO_STATUS_CAPS[status]}
                  </span>
                  <TeamDemoPatternSubline pattern={pattern} />
                </div>
                <ChevronRight
                  className={styles["team-demo-card-chevron"]}
                  size={22}
                  strokeWidth={2}
                  aria-hidden
                />
              </div>
            </button>
          ))}
        </div>
      </div>

      <div
        style={{
          marginTop: "auto",
          padding: "16px",
          paddingBottom: "max(16px, env(safe-area-inset-bottom, 0px))",
        }}
      >
        <button
          type="button"
          className="proceed-button"
          onClick={() => {
            setHasSeenTeamDemo();
            navigate("/app/demo-team/next");
          }}
        >
          Start using the app
        </button>
      </div>
    </div>
  );
};

export default TeamDemo;
